/*eslint-disable no-undef */
import phina from 'phina.js'
import April from '../../ALizard/April'

export default ()=>{
  April.define('story-note.message-open', function(args){
    var player = args.scene;
    player.message = phina.display.DisplayElement({
      width:960, height:180,
    }).setPosition(0, 200)
    .addChildTo(player.front);
    player.message.bg = phina.display.RectangleShape({
      width:960, height:180,
      fill:'#000', stroke:'transparent',
    }).setPosition(0,0).fromJSON({ alpha:0.5 })
    .addChildTo(player.message)
    player.message.icon = phina.display.Sprite('noimage')
    .setSize(120,120).setPosition(-400,-20)
    .addChildTo(player.message)
    // var msg = phina.display.StackLayout({})
    // .addChildTo(player.message)
    player.message.name = phina.display.LabelArea({
      width:800, height:30,
      text:'', fill:'#FFF', align:'left', fontSize:26,
    }).setPosition(80,-75)
    .addChildTo(player.message)
    player.message.text = phina.display.LabelArea2({
      width:800, height:120,
      text:'', fill:'#FFF', align:'left', fontSize:22,
      autoHeight:true,
    }).setPosition(80,20)
    .addChildTo(player.message)
    return true;
  });
  April.define('story-note.message-close', function(args){
    var player = args.scene;
    player.message.remove();
    return true;
  });
  April.define('story-note.remark', function(args){
    var player = args.scene;
    player.message.text.text = (args.text||'')
      .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
      .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
    player.message.name.text = args.name||'';
    player.message.icon.image = args.icon||'noimage';
    player.message.icon.image.domElement.setAttribute('crossOrigin', '');
    player.message.icon.setSize(120,120);
    player.message.text.one('showed', ()=>{
      player.next(4000);
    })
    return false;
  });
  April.define('story-note.text-note', function(args){
    var player = args.scene;
    player.message.name.text = '';
    player.message.text.text = (args.text || '')
      .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
      .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
    player.message.text.one('showed', ()=>{
      player.next(4000);
    })
    return false;
  });
  var dice = ['⚀','⚁','⚂','⚃','⚄','⚅'];
  April.define('story-note.dice', function(args){
    var player = args.scene;
    var total = 0;
    player.message.text.text = '【{0}のダイスロール！】'.format(args.name);
    player.tweener.clear()
    args.dice.forEach((v)=>{
      total += v;
      player.tweener
        .wait(500)
        .call(()=>{ player.message.text.text += dice[v-1] })
    })
    player.tweener
      .wait(500)
      .call(()=>{ 
        total += args.ext;
        if(args.ext > 0){ player.message.text.text += "＋{0}".format(args.ext) }
        else if(args.ext < 0){ player.message.text.text += "－{0}".format(-args.ext) }
      })
      .wait(500)
      .call(()=>{ player.message.text.text += "⇒" })
      .wait(1000)
      .call(()=>{ 
        if(total >= args.target){ player.message.text.text += "{0}【成功】".format(total) }
        else{ player.message.text.text += "{0}【失敗】".format(total) }
      })
      .wait(3000)
      .call(()=>{player.play()})
    return false;
  });
  April.define('story-note.dice-shot', function(args){
    var player = args.scene;
    var total1 = 0, total2 = 0;
    player.message.text.text = '【{0}のダイスショット！】'.format(args.name1);
    player.tweener.clear()
    args.dice1.forEach((v)=>{
      total1 += v;
      player.tweener
        .wait(500)
        .call(()=>{ player.message.text.text += dice[v-1] })
    })
    player.tweener
      .wait(500)
      .call(()=>{ 
        total1 += args.ext1;
        if(args.ext1 > 0){ player.message.text.text += "＋{0}".format(args.ext1) }
        else if(args.ext1 < 0){ player.message.text.text += "－{0}".format(-args.ext1) }
      })
      .wait(500)
      .call(()=>{ player.message.text.text += "⇒{0}\n".format(total1) })
      .wait(1000)
      .call(()=>{ player.message.text.text += '【{0}のダイスショット！】'.format(args.name2) })
    args.dice2.forEach((v)=>{
      total2 += v;
      player.tweener
        .wait(500)
        .call(()=>{ player.message.text.text += dice[v-1] })
    })
    player.tweener
      .wait(500)
      .call(()=>{ 
        total2 += args.ext2;
        if(args.ext2 > 0){ player.message.text.text += "＋{0}".format(args.ext2) }
        else if(args.ext2 < 0){ player.message.text.text += "－{0}".format(-args.ext2) }
      })
      .wait(500)
      .call(()=>{ player.message.text.text += "⇒{0}\n".format(total2) })
      .wait(1000)
      .call(()=>{ 
        if(total1 > total2){ player.message.text.text += "勝利！" }
        else{ player.message.text.text += "敗北…" }
      })
      .wait(3000)
      .call(()=>{player.play()})
    return false;
  });
  April.define('story-note.status', function(args){
    var player = args.scene;
    if(!args.hide){
      player.message.text.text = "【{name}の{status}が{up}増加！】".format(args);
      player.message.text.one('showed', ()=>{
        player.next(3000);
      })
      return false;
    }else{
      return true;
    }
  });
  April.define('story-note.wait-click', function(){
    // var player = args.scene;
    return false;
  });
  April.define('story-note.set-bg', function(args){
    var player = args.scene;
    var obg = player.bg2.children[0];
    var bg = phina.display.Sprite(args.src)
    .fromJSON({ alpha:args.anime ?0 :1 })
    .setPosition(0,0)
    .addChildTo(player.bg2)
    if(args.anime){
      bg.tweener
        .clear()
        .fadeIn(1000)
        .call(()=>{
          if(obg){ obg.remove(); }
          player.play();
        })
      return false;
    }else{
      if(obg){ obg.remove(); }
      return true;
    }
  });
  April.define('story-note.weather', function(args){
    var player = args.scene;
    var obg = player.bg3.children[0];
    var bg;
    if(args.value === 'rain'){
      bg = RainFilter({ width:args.scene.width, height:args.scene.height })
      .fromJSON({ alpha:args.anime ?0 :1 })
      .setPosition(-500,-300)
      .addChildTo(player.bg3)
    }else{
      bg = phina.display.DisplayElement()
      .addChildTo(player.bg3)
    }
    if(args.anime){
      obg && obg.tweener
        .clear()
        .fadeOut(1000)
      bg.tweener
        .clear()
        .fadeIn(1000)
        .call(()=>{
          if(obg){ obg.remove(); }
          player.play();
        })
      return false;
    }else{
      if(obg){ obg.remove(); }
      return true;
    }
  });
  April.define('story-note.clear', function(args){
    var player = args.scene;
    var layer = player[args.layer];
    var children = layer.children.clone();
    if(args.anime){
      layer.tweener
        .clear()
        .fadeOut(1000)
        .call(()=>{
          children.forEach(v => v.remove());
        })
        .set({alpha:1.0})
        .call(()=>{
          player.play();
        })
      return false;
    }else{
      children.forEach(v => v.remove());
      player[args.layer].alpha = 1.0;          
      return true;
    }
  });
  April.define('story-note.fade-in', function(args){
    var player = args.scene;
    player.black.tweener
      .clear()
      .fadeOut(2000)
      .call(player.play.bind(player))
    player.playing = false;
    return false;
  });
  April.define('story-note.fade-out', function(args){
    var player = args.scene;
    player.black.tweener
      .clear()
      .fadeIn(2000)
      .call(player.play.bind(player))
    player.playing = false;
    return false;
  });
  April.define('story-note.black-out', function(args){
    var player = args.scene;
    if(!player.black){
      player.black = phina.display.RectangleShape({
        width:1000, height:600,
        fill:'#000', stroke:'transparent'
      }).setPosition(0,0)
      .addChildTo(player.front2);
    }
    player.black.alpha = 1.0;
    return true;
  });
  April.define('story-note.introduction', function(args){
    var player = args.scene;

    phina.display.Sprite('img/ui/paper.png')
    .setPosition(0,0)
    .addChildTo(player.front3)

    if(args.image){
      phina.display.Sprite(args.image)
      .setSize(210, 300)
      .setPosition(0,-20)
      .addChildTo(player.front3)
    }else if(args.icon){
      phina.display.Sprite(args.icon)
      .setSize(120, 120)
      .setPosition(0,-90)
      .addChildTo(player.front3)
    }

    var characterName = phina.display.RectangleShape({
      width:450, height:50, fill:'transparent',stroke:'transparent'
    }).setPosition(0, -230)
    .addChildTo(player.front3)
    phina.display.Sprite("img/ui/header_bg1.png")
    .addChildTo(characterName).setSize(450,40).setPosition(0,25);
    phina.display.Label({
      text: args.memo,
      fill:'#000', fontSize:18, align:'left'
    }).addChildTo(characterName).setPosition(-240,-50);
    if(args.eno > 0){
      phina.display.Label({
        text: 'ENo.{0}'.format(args.eno),
        fill:'#000', fontSize:20,
      }).addChildTo(characterName).setPosition(-180,-30);
    }
    phina.display.Label({
      text: args.name, width:1000,
      fill:'#000', fontSize:32, stroke:'#FFF'
    }).addChildTo(characterName).setPosition(0,0);

    phina.display.RectangleShape({
      width:800, height:200,
      fill:'#000', stroke:'transparent'
    }).fromJSON({ alpha:0.3 }).setPosition(0, 240)
    .addChildTo(player.front3)
    phina.display.LabelArea2({
      width:800, height:150,
      text:'',
      fill:'#FFF', verticalAlign:'top', align:'left', fontSize:22,
      autoHeight:true,
    }).setPosition(0,230)
    .addChildTo(player.front3)
    .one('showed', ()=>{
      player.next(5000);
    })
    .fromJSON({ text: (args.note||'')
      .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
      .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
    })

    return false;
  });
  April.define('story-note.telop', function(args){
    var player = args.scene;

    phina.display.LabelArea2({
      width:500, height:250,
      text:'',
      fill:'#FFF', verticalAlign:'top', align:'center', fontSize:22,
      autoHeight:true,
    }).setPosition(0,50)
    .addChildTo(player.front3)
    .one('showed', ()=>{
      player.next(5000);
    })
    .fromJSON({ text: (args.text||'')
      .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
      .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
    })

    return false;
  });
  April.define('story-note.heading', function(){
    // var player = args.scene;
    // player.message.name.text = '';
    // player.message.text.text = (args.text || '')
    //   .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
    //   .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
    // player.message.text.one('showed', ()=>{
    //   player.next(4000);
    // })
    return true;
  });
  April.define('story-note.link-text', function(){
    // var player = args.scene;
    return true;
  });
}
